/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useState } from 'react';
import { Modal, ModalBody, Button, Input, InputGroup, InputGroupText } from 'reactstrap';
import { FaSearch } from 'react-icons/fa';
import moment from 'moment';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const CommentsModal = ({ comments, modalOpen, setModalOpen }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const toggleModal = () => setModalOpen(!modalOpen);

  const filteredComments = comments?.filter((c) =>
    c.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <>
      <Modal isOpen={modalOpen} toggle={toggleModal} size="xl">
        {/* Header customizado */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 20px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            borderBottom: '1px solid #e0e0e0',
            height: 84,
          }}
        >
          <h5 style={{ margin: 0, color: '#2A2C85' }}>Comentários</h5>

          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            <InputGroup style={{ maxWidth: '250px', flex: 1, margin: '0 20px' }}>
              <InputGroupText>
                <FaSearch />
              </InputGroupText>
              <Input
                placeholder="Pesquisar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>

            <Button close onClick={toggleModal} />
          </div>
        </div>

        <ModalBody style={{ padding: 0, maxHeight: '60vh', overflowY: 'auto' }}>
          {filteredComments?.length === 0 ? (
            <p style={{ color: '#999', textAlign: 'center' }}>Nenhum comentário encontrado</p>
          ) : (
            filteredComments?.map((comment, index) => {
              const date = moment(comment.created_at).format('DD/MM/YYYY');
              const time = moment(comment.created_at).format('HH:mm');

              return (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    marginBottom: '20px',
                    alignItems: 'flex-start',
                    gap: '15px',
                    flexDirection: 'column',
                    paddingLeft: 40,
                    paddingRight: 40,
                    paddingTop: 15,
                    paddingBottom: 15,
                    borderBottom: '1px solid #EEF0F3',
                  }}
                >
                  {/* Conteúdo do comentário */}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 500, color: '#5A5A5A' }}>
                      {`${comment?.type} ${comment?.title}`}
                    </div>
                    <div style={{ fontSize: '16px', fontWeight: 400, color: '#5A5A5A' }}>
                      {comment?.text}
                    </div>
                  </div>

                  {/* Separator vertical com data e hora */}
                  <div
                    style={{
                      borderLeft: '2px solid #0E134EBF',
                      paddingLeft: '10px',
                      textAlign: 'start',
                      minWidth: '70px',
                    }}
                  >
                    <div style={{ fontSize: '14px', color: '#555' }}>Data: {date}</div>
                    <div style={{ fontSize: '14px', color: '#555' }}>Horário: {time}</div>
                  </div>
                </div>
              );
            })
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default CommentsModal;
